type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref = "#top",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-primary-600">
          <span className="h-3 w-1 rounded-full bg-accent-500" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
        )}
      </div>
      {actionLabel && (
        <a
          href={actionHref}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {actionLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base" />
          </span>
        </a>
      )}
    </div>
  );
}